import { Box, Container } from '@mui/material'
import PageHeader from 'components/common/PageHeader/PageHeader';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import useStyles from './styles';
import PersonAddIcon from 'icons/PersonAddIcon';
import { useNavigate } from 'react-router-dom';
import AllPatientsTable from 'components/tables/AllPatients/AllPatientsTable';
import useGlobalStyles from 'styles/globalStyles';

export default function AllCasesPage() {
  const globalStyles = useGlobalStyles();
  const navigate = useNavigate();

  const navigateToAddCase = () => {
    navigate('/patients/add');
  }


  return (
    <Box className={globalStyles.container} p={3}>
        <Box>
          <PageHeader
            title={'Patients List'}
            buttons={[
              <CustomButton
                key='add-patient'
                text='Add Patient'
                color='primary'
                icon={<PersonAddIcon size={15} />}
                onClick={navigateToAddCase}
              />
            ]}
          />
        </Box>

        <Box mt={3}>
          <AllPatientsTable />
        </Box>
    </Box>
  )
}
